import { render, staticRenderFns } from "./ProfileEditFooter.vue?vue&type=template&id=eca5ac06&"
import script from "./ProfileEditFooter.vue?vue&type=script&lang=js&"
export * from "./ProfileEditFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports